export default __webpack_public_path__ + "static/latitiude-scam-alert-10-0fa3077994e5a033752b5f2435d1ab09.png";